import { render, staticRenderFns } from "./CustomerCreditMemoBalance.vue?vue&type=template&id=45ddd194&"
import script from "./CustomerCreditMemoBalance.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditMemoBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports